import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Draggable wrapper for a single Kanban card.
// - data.type lets the board's onDragEnd tell cards apart from columns.
// - clickGuardRef (optional): a ref set to true right after a drag ends;
//   the capture-phase click check below swallows the ghost click that
//   browsers fire after a drop, so dragging never opens the task modal.
const SortableCard = ({ id, clickGuardRef, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    data: { type: "card" },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 50 : undefined,
    position: "relative",
  };

  // Starting a drag on a card must not also start a column drag or the
  // board's mouse-pan scroll — stop the events from bubbling up.
  const isolatedListeners = {
    ...listeners,
    onPointerDown: (e) => {
      e.stopPropagation();
      listeners?.onPointerDown?.(e);
    },
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...isolatedListeners}
      onMouseDown={(e) => e.stopPropagation()}
      onClickCapture={(e) => {
        if (clickGuardRef?.current) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      {children}
    </div>
  );
};

export default SortableCard;
